import React from "react";
import { Button, Row, Col, Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import SectionSeparator from "../SectionSeparator";
import SignaturePad from "../SignaturePad";

const TermsConditionsStep = ({ ctx }) => {
  const { admissionAttachments, errors, formData, setAdmissionAttachmentModal, setFormData, setSignature, signature } = ctx;
  return <>
                {admissionAttachments.length > 0 && <>
                    <SectionSeparator title="title.settling_in_policy" />
                    <ul>
                      {admissionAttachments.map((attachment, index) => <li key={index}>
                          <Button onClick={() => setAdmissionAttachmentModal({
          show: true,
          title: attachment.title,
          content: attachment.text
        })} variant="link">
                            {attachment.title}
                          </Button>
                        </li>)}
                    </ul>
                  </>}
                <SectionSeparator title="title.acknowledgement" />
                <Row className="mb-4">
                  <Col md={"auto"}>
                    <Form.Check checked={Number(formData?.check_acknowledgement) === 1} type="checkbox" onChange={e => setFormData(prev => ({
        ...prev,
        check_acknowledgement: e.target.checked ? 1 : 0
      }))} />
                  </Col>
                  <Col>
                    <FormattedMessage id="acknowledgement" />
                  </Col>
                </Row>
                <SignaturePad signature={signature} setSignature={setSignature} admissionID={formData.admission_id} setFormData={setFormData} error={errors?.signature} />
              </>;
};

export default TermsConditionsStep;
